import React, { useState } from "react";
// import "./uploadFeed.scss";
import { createFeed, fileUpload, fileUploadAfterSignURL } from "../../../actions/emActions";
import Dropzone from "react-dropzone";
import { Spinner } from "reactstrap";
import $ from "jquery";

const UploadVideo = (props) => {
  const {
    programs,
    preview,
    selectedFile,
    handleFileChange,
    setSelectedFile,
    headingText,
    uploadFunc,
    loader,
    addedVideo,
  } = props;

  const [text, setText] = useState("");

  const [programInfo, setprogramInfo] = useState("");
  const [worksheetFileData, setworksheetFileData] = useState("");
  const [uploadLoading, setuploadLoading] = useState(false);

  console.log("selectedFile", selectedFile);
  console.log("selectedFile", worksheetFileData);
  console.log("programInfo", programInfo && JSON.parse(programInfo)?.progid);
  // console.log("programInfo", JSON.parse(programInfo));

  return (
    <div className="">
      <div className="card text-left uploadFeed">
        <div className="card-body">
          <div className="d-flex justify-content-between">
            <h5 className="card-title mb-0">{headingText}</h5>
            {/* {selectedFile && (
              <button className="btn btn-light btn-sm" onClick={() => setSelectedFile("")}>
                Change photo/video
              </button>
            )} */}
          </div>
          {addedVideo === "" ? (
            <form className="mt-3 row">
              {!selectedFile && (
                <div className="col-md-12">
                  <Dropzone
                    onDrop={(acceptedFiles) => handleFileChange(acceptedFiles)}
                    accept=".mp4 , MP4 , .webm"
                    multiple={false}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div {...getRootProps({ className: "dropzone" })}>
                        <input {...getInputProps()} />
                        <p>Drag 'n' drop video here, or click to select video</p>
                      </div>
                    )}
                  </Dropzone>
                </div>
              )}
              {selectedFile && (
                <>
                  <div className="col-md-8">
                    {/* <p className="mb-0">In which course you want to upload?</p> */}
                    {/* <select
                    className="form-control form-control-sm"
                    onChange={(e) => setprogramInfo(e.target.value)}
                  >
                    <option>Courses</option>
                    {programs?.map((item) => (
                      <option value={JSON.stringify(item)}> {item?.prog_name} </option>
                    ))}
                  </select> */}
                    <div className="p-2">
                      {programs?.map((item) => (
                        <div>
                          <input
                            type="radio"
                            onClick={(e) => setprogramInfo(e.target.value)}
                            value={JSON.stringify(item)}
                            checked={
                              programInfo && JSON.parse(programInfo)?.progid === item?.progid
                            }
                          />
                          <label className="ml-2">{item?.prog_name}</label>
                        </div>
                      ))}
                    </div>
                  </div>
                  {/* <div className="col-md-12 mt-3">
                  <textarea
                    type="text"
                    placeholder="Add caption here"
                    className="form-control form-control-sm"
                    id="textInput"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                  />
                </div> */}
                  <div className="col-md-12">
                    {selectedFile && (
                      <div className="text-right mt-1">
                        {selectedFile && (
                          <button
                            className="btn btn-light btn-sm"
                            onClick={() => setSelectedFile("")}
                          >
                            Remove this photo/video <i className="fa fa-trash-o text-danger" />
                          </button>
                        )}
                        <div className="text-center">
                          {selectedFile.type.startsWith("image/") ? (
                            <img
                              width={"100%"}
                              // height={150}
                              src={preview}
                              alt="Preview"
                              className="rounded"
                            />
                          ) : (
                            <video preload="metadata" className="w-100" playsInline controls>
                              <source
                                src={`${URL.createObjectURL(selectedFile)}#t=0.001`}
                                type={selectedFile.type}
                              />
                              Your browser does not support the video tag.
                            </video>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}
              <div className="col-md-12 mt-3">
                <div className="d-flex justify-content-between">
                  <a
                    href="https://lincolnmethod.com/privacy-policy"
                    target="__blank"
                    className="termsServiceText my-auto"
                  >
                    See terms of service
                  </a>
                  <div className="text-right">
                    <button
                      // type="submit"
                      disabled={selectedFile && !loader ? false : true}
                      className="uploadBtn"
                      onClick={() => uploadFunc()}
                    >
                      {loader ? <Spinner size="sm" /> : "Upload"}
                    </button>
                    <br />
                    {selectedFile && (
                      <span className="text-danger" style={{ fontSize: 14 }}>
                        *Press upload button to upload this video
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </form>
          ) : (
            <div className="text-center mt-3">
              <video preload="metadata" className="w-100" playsInline controls>
                <source src={`${addedVideo}#t=0.001`} />
                Your browser does not support the video tag.
              </video>
            </div>
          )}
        </div>
      </div>

      <div className="modalForZoomLink">
        <div class="modal fade" tabindex="-1" role="dialog" id="uploadconfirmPopup">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <div className="text-center">
                  <i className="fas fa-smile mr-3 fa-4x text-warning"></i>
                  <h5 className="font-weight-bold mt-3">Are you sure?</h5>
                  <br />
                  <p>
                    {" "}
                    Your photo/video will be shared on our platform. Your Tutor and other classmates
                    may also be able to see this.
                  </p>
                </div>
                <div className="text-center">
                  <button
                    className="btn btn-success btn-block"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => uploadFunc()}
                  >
                    Upload
                  </button>
                </div>
                <div className="text-center mt-3">
                  <p
                    className="text-primary"
                    onClick={() => $("#uploadconfirmPopup").modal("hide")}
                  >
                    Don't upload Image/Video
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadVideo;
